import { useIsFetching, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '../../../constants/index';
import { useCompanyContextReady } from '../../../hooks/company/use-company-context-ready.hook';

const eventsQueryMatchesCompany = (companyId: string, queryKey: readonly unknown[]) =>
  queryKey[0] === QueryKey.GET_EVENTS &&
  typeof queryKey[1] === 'object' &&
  queryKey[1] != null &&
  'companyId' in queryKey[1] &&
  (queryKey[1] as { companyId: string }).companyId === companyId;

export const useEventsSecondaryQueriesEnabled = (companyId: string) => {
  const isCompanyContextReady = useCompanyContextReady(companyId);
  const queryClient = useQueryClient();

  const isEventsFetching =
    useIsFetching({
      predicate: (query) => eventsQueryMatchesCompany(companyId, query.queryKey),
    }) > 0;

  const hasEventsData = queryClient
    .getQueryCache()
    .findAll({
      predicate: (query) => eventsQueryMatchesCompany(companyId, query.queryKey),
    })
    .some((query) => query.state.data !== undefined);

  return isCompanyContextReady && (hasEventsData || !isEventsFetching);
};
